(function () {
  var REVEAL_SELECTOR = ".reveal-card";
  var VISIBLE_CLASS = "reveal-card--visible";

  function revealElement(el) {
    if (!el) return;
    el.classList.add(VISIBLE_CLASS);
    el.classList.remove("reveal-card");
  }

  function initRevealInScope(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll(REVEAL_SELECTOR);
    if (!elements.length) return;

    if (!("IntersectionObserver" in window)) {
      // Fallback: no IO support, just reveal everything
      elements.forEach(revealElement);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealElement(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.25
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Initial page load
  document.addEventListener("DOMContentLoaded", function () {
    initRevealInScope(document);
  });

  // When a section is loaded / reloaded in the theme editor
  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.target) {
      initRevealInScope(event.target);
    } else {
      initRevealInScope(document);
    }
  });
})();
